'use client';

import React from 'react';
import { Box } from '@skin-seoul/design-system';
import { ProductType, type RecommendedProduct } from '@skin-seoul/service';
import MobileRecentlyViewedProductCard from './cards/MobileRecentlyViewedProductCard';
import RecentlyViewedProductsScrollSkeleton from './RecentlyViewedProductsScroll.skeleton';
import { useProductCompareContext } from '../context/ProductCompareContext';
import { useCenterScroll } from '../hooks/useCenterScroll';
import { trackAddToCartAICompare } from '../utils/analytics';
const scrollableStyle = {
  scrollSnapType: 'x mandatory',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  scrollbarWidth: 'none'
} as const;
interface RecentlyViewedProductsScrollProps {
  selectedProductId: number | undefined;
  onProductClick: (productId: number, productLink: string) => void;
  recentlyViewedProducts: RecommendedProduct[];
}
const RecentlyViewedProductsScroll = ({
  selectedProductId,
  onProductClick,
  recentlyViewedProducts
}: RecentlyViewedProductsScrollProps) => {
  const {
    currentProductId
  } = useProductCompareContext();
  const {
    scrollRef,
    registerItemRef
  } = useCenterScroll({
    centerId: selectedProductId ?? currentProductId,
    items: recentlyViewedProducts
  });
  return <Box ref={scrollRef} display="flex" overflowX="auto" gap={4} py={2} css={scrollableStyle} data-sentry-element="Box" data-sentry-component="RecentlyViewedProductsScroll" data-sentry-source-file="RecentlyViewedProductsScroll.tsx">
      {recentlyViewedProducts.map((product, index) => {
      const productId = product.parentProductId ?? product.productId;
      const isDisabled = productId === currentProductId && selectedProductId === productId;
      return <Box key={product.productId} ref={registerItemRef(productId)} ml={index === 0 ? 'calc(50vw - 152px)' : 0} mr={index === recentlyViewedProducts.length - 1 ? 'calc(50vw - 152px)' : 0} minWidth="304px" gap={0} scrollSnapAlign="center" display="flex">
            <MobileRecentlyViewedProductCard sku={product.sku} href={product.productLink} name={product.name} brand={product.brand} productImage={product.productImageUrls[0]} currency={product.currency} originalPrice={product.originalPrice} salePrice={product.salePrice} productType={ProductType.Simple} isSelected={selectedProductId === productId} isDisabled={isDisabled} onTrackAddToCart={() => trackAddToCartAICompare(product)} onClick={e => {
          e.preventDefault();
          if (!isDisabled) {
            onProductClick(productId, product.productLink);
          }
        }} />
          </Box>;
    })}
    </Box>;
};
RecentlyViewedProductsScroll.Skeleton = RecentlyViewedProductsScrollSkeleton;
export default RecentlyViewedProductsScroll;